/**
 * Информация — копия legacy main_information.tpl (та же лента, что новости,
 * но материалы из таблицы materials_information): заголовок, дата курсивом,
 * текст, <hr> между записями.
 */

import { Fragment } from 'react'

import type { Material } from '@/api/types'
import { useApi } from '@/lib/useApi'

export function InformationPage() {
  const { data } = useApi<Material[]>('/api/content/information')
  const news = data ?? []

  return (
    <div>
      {news.map((item, index) => (
        <Fragment key={item.id}>
          <h3>{item.title}</h3>
          <i>{item.date}</i>
          <br />
          <div dangerouslySetInnerHTML={{ __html: item.text }} />
          {index < news.length - 1 && <hr />}
        </Fragment>
      ))}
    </div>
  )
}
